export default __webpack_public_path__ + "static/merchant_large_joyce-mayne-bc455a1919a6c939774f99c0b55217bc.png";